function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.14062 2.5C8.53906 2.5 8.91406 2.66406 9.19531 2.94531L12.0547 5.80469C12.3359 6.08594 12.5 6.48438 12.5 6.85938V13C12.5 13.8203 11.8203 14.5 11 14.5H5C4.17969 14.5 3.5 13.8203 3.5 13V4C3.5 3.17969 4.17969 2.5 5 2.5H8.14062ZM5 3.625C4.78906 3.625 4.625 3.78906 4.625 4V13C4.625 13.2109 4.78906 13.375 5 13.375H11C11.2109 13.375 11.375 13.2109 11.375 13V7.375H9.3125C8.375 7.375 7.625 6.625 7.625 5.6875V3.625H5ZM8.86719 8.6875C9.05469 8.42969 9.40625 8.38281 9.64062 8.57031C9.89844 8.73438 9.94531 9.08594 9.78125 9.34375L7.97656 11.8047C7.88281 11.9453 7.74219 12.0156 7.57812 12.0391C7.41406 12.0391 7.25 11.9688 7.13281 11.8516L6.28906 10.9844C6.07812 10.7734 6.07812 10.3984 6.28906 10.1875C6.52344 9.97656 6.875 9.97656 7.08594 10.2109L7.46094 10.5859L8.86719 8.6875ZM8.75 5.6875C8.75 5.99219 9.00781 6.25 9.3125 6.25H10.9062L8.75 4.09375V5.6875Z",
  fill: "#636766"
});

function SvgSaqIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaqIcon);
export default __webpack_public_path__ + "static/media/saq-icon.9ff7a777.svg";
export { ForwardRef as ReactComponent };